import { orderBy } from "lodash";

import { Lesson, TimeOff } from "@hubcapp/types";

import { LessonSummary } from "./types";

type CalendarEvents = (Lesson | TimeOff)[];

export const mapEventsToLessonSummaries = (
  events: CalendarEvents,
): LessonSummary[] =>
  orderBy(
    events
      .map((calendarEvent: Lesson | TimeOff) => {
        if (calendarEvent.__typename === "Lesson") {
          return {
            ...calendarEvent,
            learnerId: calendarEvent.learner?.id,
            endDateTime: calendarEvent.endDateTime,
            startDateTime: calendarEvent.startDateTime,
            learnerName: `${calendarEvent.learner?.name.firstName} ${calendarEvent.learner?.name.lastName}`,
            pickupPostcode: calendarEvent.learner?.pickupAddress?.postcode,
          } as LessonSummary;
        }
      })
      .filter(Boolean) as LessonSummary[],
    "startDateTime",
    "asc",
  );
